import { render } from "./login-suomi.vue?vue&type=template&id=5b7bf82e&scoped=true&lang=pug"
import script from "./login-suomi.vue?vue&type=script&lang=js"
export * from "./login-suomi.vue?vue&type=script&lang=js"

import "./login-suomi.vue?vue&type=style&index=0&id=5b7bf82e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7bf82e"]])

export default __exports__